import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import {
  createSelectedItemsSlice,
  type SelectedItemsState,
} from "../../../Application/slices/createSelectedItemsSlice";
import { type EmbeddedVideoUser } from "../types/models";

export interface EmbeddedVideoUsersState extends SelectedItemsState<EmbeddedVideoUser> {}

const initialState: EmbeddedVideoUsersState = {
  items: [],
  itemsCount: 0,
  selectedIds: [],
  isLoading: false,
  error: undefined,
  selectedItems: [],
};

const embeddedVideoUsersSlice = createSelectedItemsSlice(
  { namespace: ReducerNamespaceTypes.Library, entity: ReducerEntityPrefixTypes.EmbeddedVideos, name: "users" },
  initialState,
);

export const { fetchBegin, fetchSuccess, fetchFailure, selectedItemsChanged, resetSelectedItems } =
  embeddedVideoUsersSlice.actions;

export default embeddedVideoUsersSlice.reducer;
